import { AppDispatch } from '../store/store';

import {
  setIsLoggedIn,
  setIsClient,
  setUserInfo,
  setIsValidated,
  setRoles,
  setInterviewers,
  setUserProfile,
  setProfileRequest,
  setUserCompany,
  setNotifications,
  setNotificationsSendCount
} from '../store/slices/authSlice';
import {
  showLoading,
  loadingMessage,
  showErrorMessage, showToastMessage,
} from '../store/slices/alertsSlice';
import * as api from '../api/serviceApi';
import AsyncStorage from '@react-native-async-storage/async-storage';

export const validateLoginAction = () => (dispatch: AppDispatch) => {
  const fakeCall = new Promise((resolve) => {
    resolve('');
  });

  fakeCall.then(async () => {
    const token = await AsyncStorage.getItem('USER_TOKEN');
    const userInfoString = await AsyncStorage.getItem('USER_INFO');

    if (token && userInfoString) {
      const userInfo = JSON.parse(userInfoString);
      //const isClient = userInfo.profile.name == 'CLIENT';

      dispatch(setUserInfo(userInfo));
      dispatch(setIsLoggedIn(true));
      // dispatch(setIsClient(isClient));
      // dispatch(setRoles(userInfo.profile.roles))
    } else {
      await AsyncStorage.clear();
    }

    dispatch(setIsValidated(true));
  });
};

export const doLoginAction = (username: string, password: string) => (dispatch: AppDispatch) => {
  dispatch(showLoading(true));
  dispatch(loadingMessage('Login ...'));

  const request = { email: username, password: password };
  api.postLogin(request).then(async result => {
    await AsyncStorage.setItem('USER_INFO', JSON.stringify(result.user));
    dispatch(setUserInfo(result.user));
    dispatch(setIsLoggedIn(true));
  }).catch(() => {
    //msg error
    dispatch(showErrorMessage("Incorrect username and password"));
  }).finally(() => {
    dispatch(showLoading(false));
  });
};

export const getUserInfo = () => async (dispatch: AppDispatch) => {
  const userInfoString = await AsyncStorage.getItem('USER_INFO');

  if (userInfoString) {
    const userInfo = JSON.parse(userInfoString);
    dispatch(showLoading(true));
    dispatch(loadingMessage('Cargando ...'));

    api.gerInfoUser(userInfo.id).then(async result => {
      await AsyncStorage.setItem('USER_INFO', JSON.stringify(result));

      dispatch(setUserInfo(result));
      //  dispatch(setIsLoggedIn(true));
    }).catch((error) => {
      //error msg
      dispatch(showErrorMessage(error));
    }).finally(() => {
      dispatch(showLoading(false));
    });
  }
  };

  export const logout = (navigation: any) => async (dispatch: AppDispatch) => {
    await AsyncStorage.clear();

    dispatch(setUserInfo(null));
    dispatch(setIsLoggedIn(false));
  };

  export const getInterviewersAction = () => (dispatch: AppDispatch) => {
    dispatch(showLoading(true));
    dispatch(loadingMessage('Login ...'));

    api.getInterviewers().then(result => {
      dispatch(setInterviewers(result.users))
    }).catch((error) => {
      //content msg error
      dispatch(showErrorMessage(error));
    }).finally(() => {
      dispatch(showLoading(false));
    });
  };

  export const getUserDataAction = (userId: number) => (dispatch: AppDispatch) => {
    dispatch(showLoading(true));
    dispatch(loadingMessage('Getting user data'));

    api.getUser(userId).then(result => {
      dispatch(setUserProfile(result[0]))
      dispatch(getProfileRequestAction())
    }).catch((error) => {
      //content msg error
      dispatch(showErrorMessage(error));
    }).finally(() => {
      dispatch(showLoading(false));
    });
  };

  export const getProfileRequestAction = () => (dispatch: AppDispatch) => {
    dispatch(showLoading(true));
    dispatch(loadingMessage('Getting the profile data'));

    api.getConfigUser()
      .then(result => {
        dispatch(setProfileRequest(result))
      })
      .catch((error) => {
        //content msg error
        dispatch(showErrorMessage(error));
      })
      .finally(() => {
        dispatch(showLoading(false));
      });
  };

  export const updateProfileRequestAction = (idUser: number, body: IUserConfigModel) => (dispatch: AppDispatch) => {
    dispatch(showLoading(true));
    dispatch(loadingMessage('Updating the user profile'));

    api.updateUserConfiguration(idUser, body)
      .then(() => {
        dispatch(getProfileRequestAction())
        dispatch(showToastMessage("The profile was updated success!"))
      })
      .catch(error => {
        dispatch(showErrorMessage(error));
      })
      .finally(() => {
        dispatch(showLoading(false));
      });
  };

  export const getUserCompanyAction = (companyId: number) => (dispatch: AppDispatch) => {
    dispatch(showLoading(true));
    dispatch(loadingMessage('Getting the company data'));

    api.getCompany(companyId)
      .then(result => {
        dispatch(setUserCompany(result))
      })
      .catch((error) => {
        //content msg error
        dispatch(showErrorMessage(error));
      })
      .finally(() => {
        dispatch(showLoading(false));
      });
  };
